<template>
  <div id="login">
    <img src="@/assets/header_home.png" alt class="small-header" />
    <img src="@/assets/logo_home.png" alt class="logo" />
    <form class="form">
      <div>
        <label for="username">Username</label>
        <input
          v-model="username"
          autocomplete="username"
          type="text"
          name="username"
          class="mb-3"
          @keyup.enter="login"
        />

        <label for="password">Password</label>
        <input
          v-model="password"
          type="password"
          name="password"
          autocomplete="current-password"
          @keyup.enter="login"
        />
      </div>
      <button type="button" class="search-button" @click="login">OK</button>
    </form>
    <p v-if="logginError">Wrong login or password.</p>
  </div>
</template>

<script>
import Store from "@/store";
import axios from "axios";

export default {
  data() {
    return {
      username: "",
      password: "",
      store: Store.state,
      logginError: false
    };
  },
  methods: {
    login() {
      axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;
      axios
        .post(
          `cockpit/authUser?token=${process.env.VUE_APP_ROOT_API_GET_TOKEN}`,
          {
            user: this.username,
            password: this.password
          }
        )
        .then(user => {
          Store.userLogin(user);
          this.$router.push("/");
        })
        .catch(() => {
          this.logginError = true;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#login {
  height: 85vh;
  .small-header {
    width: 100%;
  }
  .logo {
    width: 40vw;
    margin: 5vh;
  }
  .form {
    width: 33vw;
    height: 40vh;
    background-color: rgba(0, 0, 0, 0.1);
    border: 2px white solid;
    border-radius: 15px;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    div {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    input {
      appearance: none;
      background-color: rgba(255, 255, 255, 0.7);
      border: 2px white solid;
      border-radius: 10px;
      &:focus {
        appearance: none;
        border-color: #ff8a5f;
        outline: none;
      }
    }
    button {
      background: linear-gradient(#ff8a5f, #dc673d);
      border-radius: 15px;
      border-color: transparent;
      font-size: 0.9em;
      color: white;
      font-weight: bold;
      width: auto;
      height: auto;
      padding: 8px;
    }
  }
}
</style>
